const _temp0 = require("../_shared/tag/svgSprite.view.less");
module.exports = {
  "less": _temp0
}